import * as USER_TYPES from './user-types'

export const ROOT = '/'

export const LOGIN = '/login'
export const HOME = '/home'

// Football development
export const FOOTBALL_DEVELOPMENT = '/football-development'

export const PLAYERS_EPPP = '/football-development/players-eppp'
export const EPPP_PLAYER_DEVELOPMENT = '/football-development/players-eppp-player-development'
export const COACHES_ECP = '/football-development/coaches-ecp'
export const MATCH_OFFICIALS_ERDP = '/football-development/match-officials-erdp'

export const HIGH_POTENTIAL = '/football-development/high-potential'
export const PERFORMANCE_PATHWAY = '/football-development/performance-pathway'
export const DUTY_OF_CARE = '/football-development/duty-of-care'
export const GOVERNANCE_AND_QA = '/football-development/governance-and-qa'
export const INNOVATION_AND_INSIGHTS = '/football-development/innovation-and-insights'
export const EQUALITY_DIVERSITY_INCLUSION = '/football-development/equality-diversity-inclusion'

// Football operations
export const FOOTBALL_OPERATIONS = '/football-operations'

export const KPIS = '/football-operations/kpis'
export const PLAYING_TIME = '/football-operations/playing-time'
export const ATTENDANCE = '/football-operations/attendance'
export const SUBSTITUTIONS = '/football-operations/substitutions'

// Football Administrations
export const FOOTBALL_ADMINISTRATION = '/football-administration'

export const TRANSFERS = '/football-administration/transfers'
export const PLAYER_REGISTRATIONS = '/football-administration/player-registrations'
export const STAFF_REGISTRATIONS = '/football-administration/staff-registrations'

export const DEFAULT = {
  [USER_TYPES.ADMIN]: HOME,
  [USER_TYPES.SUPER]: HOME,
  [USER_TYPES.GENERAL]: HOME
}
